export default {
  name: 'formatCurrency',
  filter: (
    value,
    { locale = 'en-US', currency = 'USD', minimumFractionDigits = 0, showCurrencyCode = false } = {}
  ) => {
    if (!value) {
      return '-'
    }
    if (typeof value !== 'number') {
      return value
    }
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits,
      notation: 'standard',
      currencyDisplay: 'narrowSymbol'
    })
    return showCurrencyCode ? `${formatter.format(value)} ${currency}` : formatter.format(value)
  }
}
